import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { jfePageMeta, jfeSchema } from 'components/common/schema'
import Template from 'components/cases/jfe'

const Jfe: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...jfePageMeta} />
      <JsonLd data={jfeSchema} />
      <Template />
    </>
  )
}

export default Jfe
